import { cva } from '@/styled-system/css';

export const cardHeaderRecipe = cva({
  base: {
    'marginBlockEnd': 'loose',

    '& > .c11n_heading': {
      textStyle: 'heading-xs',
    },
  },
  variants: {
    divider: {
      true: {
        paddingBlockEnd: 'default',
        borderBlockEndWidth: '{borderWidths.default}',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'border.muted-alt',
      },
      false: {},
    },
  },
});
